/** Maps integer TransactionReason values to human-readable strings.
 *
 * The index corresponds to the ``.value`` of ``TransactionReason`` on the
 * backend (see ``backend/src/core/transaction/domain.py``).
 *
 *   Unknown = 1   PackageBought = 2   TimePlayed = 3
 *   PaperWalletImport = 4   SuperuserChange = 5
 *   PresentedMinutes = 6   PackageBoughtWithPos = 7
 *   PackageBoughtWithCash = 8   InitialTopUp = 9
 *   EmailVerified = 10
 */
export const TRANSACTION_REASON_TO_TEXT = {
  ru: [
    undefined, // 0 — unused
    "Неизвестно", // 1 — Unknown
    "Покупка пакета", // 2 — PackageBought
    "Списание времени", // 3 — TimePlayed
    "Импорт абонемента", // 4 — PaperWalletImport
    "Изменение супер юзера", // 5 — SuperuserChange
    "Подарок", // 6 — PresentedMinutes
    "Покупка через POS", // 7 — PackageBoughtWithPos
    "Покупка наличными", // 8 — PackageBoughtWithCash
    "Приветственный бонус", // 9 — InitialTopUp
    "Бонус за верификацию", // 10 — EmailVerified
  ],
  en: [
    undefined, // 0
    "Unknown", // 1 — Unknown
    "Package purchase", // 2 — PackageBought
    "Time deduction", // 3 — TimePlayed
    "Pass import", // 4 — PaperWalletImport
    "Super user change", // 5 — SuperuserChange
    "Gift", // 6 — PresentedMinutes
    "POS purchase", // 7 — PackageBoughtWithPos
    "Cash purchase", // 8 — PackageBoughtWithCash
    "Welcome bonus", // 9 — InitialTopUp
    "Email verification", // 10 — EmailVerified
  ],
};
